import useProfissoes from "core/features/shared/useProfissoes";
import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

export interface SelectProfissaoProps<T = any> extends SelectBaseAntdProps<T> {}

function SelectProfissao({ ...rest }: SelectProfissaoProps) {
  const [search, setSearch] = useState<string>();

  const { isLoading, data } = useProfissoes();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione uma profissão"
      searchValue={search}
      showSearch
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectProfissao;
